<template>
  <div class="p-1" style="min-width: 100px">
    <div class="row col-12 m-auto p-0" style="border-radius: 3px; overflow: hidden;">
      <div class="col-9 m-0 p-2" :style="{backgroundColor : displayTextBgColor, color : displayTextColor}">{{ displayText }}</div>
      <div class="col-3 m-0 p-0" :style="{backgroundColor: displayTextBgColor}">
        <div v-if = "requesting" class="rounded-left m-0 p-2" :style="{backgroundColor : displayCountBgColor, color : displayCountColor}">
          <app-loading
            :spinner-only="true"
            :width="'13px'"
            :height="'13px'"
          />
        </div>
        <div v-else class="rounded-left m-0 p-2" :style="{backgroundColor : displayCountBgColor, color : displayCountColor}">
          {{ displayCount }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AppLoading from "@/components/elements/AppLoading.vue";

export default {
  name : 'DataCounter',
  components: {AppLoading},
  props : {
    displayText : {
      type : String,
      default : 'Data'
    },
    displayTextColor : {
      type : String,
      default : '#435464'
    },
    displayTextBgColor : {
      type : String,
      default : '#e1e1e1'
    },
    displayCount : {
      type : Number,
      default : 0
    },
    displayCountColor : {
      type : String,
      default : '#435464'
    },
    displayCountBgColor : {
      type : String,
      default : '#e1e1e1'
    },
    requesting: {
      type : Boolean,
      default : true
    }
  }
}
</script>

<style scoped>

</style>
